var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilSquare = function SvgPencilSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.89 8.25a.516.516 0 0 0-.515.516v5.156c0 .285-.231.516-.516.516H2.58a.516.516 0 0 1-.517-.516V3.61c0-.284.231-.515.516-.515h6.188a.516.516 0 0 0 0-1.031H2.578c-.854 0-1.547.692-1.547 1.546v10.313c0 .854.693 1.547 1.547 1.547h9.281c.855 0 1.547-.692 1.547-1.547V8.766a.516.516 0 0 0-.516-.516"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.89 1.61a1.974 1.974 0 0 0-2.791 0L5.307 8.4a.5.5 0 0 0-.124.202l-1.031 3.094a.516.516 0 0 0 .651.652l3.094-1.031a.5.5 0 0 0 .202-.125L14.89 4.4c.771-.77.771-2.02 0-2.792m-.729 2.062-6.703 6.704-2.002.668.666-2 6.706-6.703a.943.943 0 0 1 1.333 1.331"
  })));
};
export default SvgPencilSquare;